export default __webpack_public_path__ + "static/media/scratch-advance.09c2e26c.png";